'use strict';

const MAP_MODAL_ID = 'directions-and-phone-number-modal';

function init() {
  let icon;
  const $mapContainer = $('#directions-map-canvas');
  const centerLat = $mapContainer.data('center-lat');
  const centerLng = $mapContainer.data('center-lng');

  if (!centerLat || !centerLng || !$mapContainer.length) {
    return;
  }

  const mapOptions = {
    center: new google.maps.LatLng(centerLat, centerLng),
    zoom: 15,
    zoomControl: true,
    zoomControlOptions: {
      style: google.maps.ZoomControlStyle.SMALL,
      position: google.maps.ControlPosition.LEFT_TOP,
    },
    mapTypeControl: false,
    disableDefaultUI: true,
  };
  const map = new google.maps.Map(
    document.getElementById('directions-map-canvas'),
    mapOptions
  );
  const isGroupon =
    !$('body').hasClass('brand-livingsocial') &&
    !$('body').hasClass('brand-gemini');

  if (isGroupon) {
    icon = 'https://img.grouponcdn.com/mpp/hTR9ngReZbjmQWzGbV1g/Wn-27x41.png';
  } else {
    icon =
      'https://img.grouponcdn.com/sls/27C4jDdP1d9mG43yvuWTLpC1BE5S/27-28x43';
  }

  new google.maps.Marker({
    position: new google.maps.LatLng(centerLat, centerLng),
    map,
    icon,
  });
}

function onOpen() {
  const $mapContainer = $('#directions-map-canvas');

  if (!$mapContainer.length) {
    return;
  }

  const $merchantActionsModal = $(`#${MAP_MODAL_ID}`);
  let screenHeight = $(window).height();
  const headerHeight = $merchantActionsModal.find('.modal-title').outerHeight();
  const merchantActionsHeight = $merchantActionsModal
    .find('.merchant-actions')
    .outerHeight();
  screenHeight = screenHeight - headerHeight - merchantActionsHeight;
  $mapContainer.css('min-height', screenHeight);
  $mapContainer.css('max-height', screenHeight);
  Groupon.Utils.GoogleMaps.load(err => {
    // TODO: gracefully handle error
    if (err) {
      throw err;
    }

    return init();
  });
}

$(() => {
  // check if modal was open on page load before we could attach the 'modal-open' event
  if ($(`#${MAP_MODAL_ID}.show-modal`).length > 0) {
    onOpen();
  }

  $('body').on(`modal-open:${MAP_MODAL_ID}`, onOpen);

  $('.merchant-actions-container .actions-summary').click(() =>
    MPP.Modal.open(`#${MAP_MODAL_ID}`)
  );
});
